import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Service from "../../common/Service";
import LayoutHeader from "../../common/LayoutHeader";
import Footer from "../../common/LayoutFooter";
import PageLoader from "../../common/PageLoader";

const Services = () => {
  const [services, setServices] = useState([]);
  const [filteredServices, setFilteredServices] = useState([]);
  const [businessTypes, setBusinessTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [activeBusinessId, setActiveBusinessId] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/services?populate[address][populate][0]=city&populate[contact][populate]=*&populate[serviceType][populate]=*&populate[businessType][populate]=*&populate[listImage][populate]=*&populate[detailsImage][populate]=*&populate[gallery][populate]=*`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
            },
          }
        );
        const data = await response.json();
        const list = data?.data || [];
        setServices(list);
        setFilteredServices(list);
      } catch (error) {
        console.error("Error fetching services:", error);
      } finally {
        setIsLoading(false);
      }
    };

    const fetchBusinessTypes = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/business-types`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
            },
          }
        );
        const data = await response.json();
        setBusinessTypes(data?.data || []);
      } catch (error) {
        console.error("Error fetching business types:", error);
      }
    };

    fetchServices();
    fetchBusinessTypes();
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const base = process.env.PUBLIC_URL || "";

  const filterByBusiness = (id) => {
    setActiveBusinessId(id);
    if (id == null) {
      setFilteredServices(services);
      return;
    }
    setFilteredServices(
      services.filter((s) => s?.attributes?.businessType?.data?.id === id)
    );
  };

  if (isLoading) {
    return (
      <>
        <LayoutHeader />
        <PageLoader />
      </>
    );
  }

  return (
    <div className="hypena-page-wrap">
      <LayoutHeader />
      <div className="hn-breadcrumb">
        <h1>Services</h1>
        <nav className="hn-breadcrumb-nav">
          <Link to={`${base}/`} onClick={scrollTop}>Home</Link>
          <i className="bi bi-chevron-right" />
          <span>Services</span>
        </nav>
      </div>
      <section className="hn-section">
        {businessTypes?.length > 0 && (
          <div className="hn-pills">
            <button
              type="button"
              className={`hn-pill ${activeBusinessId == null ? "active" : ""}`}
              onClick={() => filterByBusiness(null)}
            >
              All <span>({services.length})</span>
            </button>
            {businessTypes.map((bt) => {
              const count = services.filter(
                (s) => s?.attributes?.businessType?.data?.id === bt.id
              ).length;
              return (
                <button
                  key={bt.id}
                  type="button"
                  className={`hn-pill ${activeBusinessId === bt.id ? "active" : ""}`}
                  onClick={() => filterByBusiness(bt.id)}
                >
                  {bt.attributes?.name} <span>({count})</span>
                </button>
              );
            })}
          </div>
        )}
        {filteredServices.length > 0 ? (
          <div className="hn-cards">
            {filteredServices.map((service) => (
              <Service key={service.id} serviceData={service} />
            ))}
          </div>
        ) : (
          <p style={{ color: "var(--hn-gray5)", textAlign: "center" }}>
            No services in this category.
          </p>
        )}
      </section>
      <Footer />
    </div>
  );
};

export default Services;
